<template>
  <div class="b-menu-breadcrumb-item__container" :style="[height, width]">
    <div class="b-menu-breadcrumb-item" :style="[backgroundColor]"
         :class="classes"
         @mouseover="onMouseOver"
         @mouseleave="onMouseLeave"
         @click="onClick">
    </div>
  </div>
</template>

<script>
import StoreHelper from '../store/helper'

export default {
  name: 'b-menu-breadcrumb-item',
  props: {
    title: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    },
    size: {
      type: Number
    }
  },
  methods: {
    onClick () { this.$emit('click') },
    onMouseOver () { this.$emit('mouseover') },
    onMouseLeave () { this.$emit('mouseleave') }
  },
  computed: {
    classes () {
      return {
        'b-menu-breadcrumb-item--active': this.active,
        [StoreHelper.getBreadcrumbItemActiveClasses()]: this.active,
        [StoreHelper.getBreadcrumbItemDefaultClasses()]: !this.active
      }
    },
    backgroundColor () {
      return { backgroundColor: this.color }
    },
    height () {
      return { height: this.size + 'px' }
    },
    width () {
      return { width: this.size + 'px' }
    }
  }
}
</script>

<style lang="scss" scoped>
$cubic-bezier: cubic-bezier(0.49, 0.68, 0.32, 1.31);

.b-menu-breadcrumb-item {
  position: relative;
  height: 75%;
  width: 75%;
  border-radius: 50%;
  cursor: pointer;
  pointer-events: all;
  transition: all 300ms $cubic-bezier;
  transition-property: height, width, margin;

  &--active {
    height: 95%;
    width: 95%;
  }

  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: margin 300ms $cubic-bezier;
  }
}
</style>
